import i18n from '@/i18n.js';
import programIcon from "@/assets/images/programs.svg";
import programActiveIcon from "@/assets/images/programsActive.svg";
import testIcon from "@/assets/images/test.svg";
import testActiveIcon from "@/assets/images/testActive.svg";
import gameLabIcon from "@/assets/images/gameLab.svg";
import gameLabActiveIcon from "@/assets/images/gameLabActive.svg";
import companyIcon from "@/assets/images/companies.svg";
import companyActiveIcon from "@/assets/images/companiesActive.svg";
import userIcon from "@/assets/images/users.svg";
import userActiveIcon from "@/assets/images/usersActive.svg";
import journeyIcon from "@/assets/images/journey.svg";
import journeyActiveIcon from "@/assets/images/journeyActive.svg";
import filesIcon from "@/assets/images/files.svg";
import filesActiveIcon from "@/assets/images/filesActive.svg";
import reviewsIcon from "@/assets/images/reviewsFill.svg";
import reviewsActiveIcon from "@/assets/images/reviewsActive.svg";
import dashboardIcon from "@/assets/images/dashboard.svg";
import dashboardActiveIcon from "@/assets/images/dashboardActive.svg";
import pagesIcon from "@/assets/images/pages.svg";
import pagesActiveIcon from "@/assets/images/pagesActive.svg";
import tagsIcon from "@/assets/images/tags.svg";
import tagsActiveIcon from "@/assets/images/tagsActive.svg";
import planeIcon from "@/assets/images/plane.svg";
import planeActiveIcon from "@/assets/images/planeActive.svg";
import blogsIcon from "@/assets/images/blogs.svg";
import blogsActiveIcon from "@/assets/images/blogsActive.svg";
import notificationsIcon from "@/assets/images/notifications.svg";
import notificationsActiveIcon from "@/assets/images/notificationsActive.svg";
import commandIcon from "@/assets/images/command.svg";
import commandActiveIcon from "@/assets/images/commandActive.svg";
import pricingIcon from "@/assets/images/pricing.svg";
import pricingActiveIcon from "@/assets/images/pricingActive.svg";
import expertIcon from "@/assets/images/experts.svg";
import expertActiveIcon from "@/assets/images/expertsActive.svg";
import reportsIcon from "@/assets/images/reports.svg";
import reportsActiveIcon from "@/assets/images/reportsActive.svg";
import gamificationIcon from "../assets/images/gamificationIcon.svg";
import gamificationActiveIcon from "../assets/images/gamificationActiveIcon.svg";
import agentsIcon from "@/assets/images/agents.svg";
import agentsActiveIcon from "@/assets/images/agentsActive.svg";
import socialIcon from "../assets/images/socialIcon.svg";
import moodsIcon from "../assets/images/moodsIcon.svg";
import moodsActiveIcon from "../assets/images/moodsActiveIcon.svg"
import marketplaceIcon from "../assets/images/marketplaceIcon.svg";
import marketplaceActiveIcon from "../assets/images/marketplaceActiveIcon.svg";

const menuRoutes = {
    content: [
        {
            path: '/programs',
            name: i18n.global.t('programs_title'),
            id: 'programs',
            icon: programIcon,
            activeIcon: programActiveIcon,
        },
        {
            path: '/tests',
            name: i18n.global.t('tests_title'),
            id: 'selfAssessments',
            icon: testIcon,
            activeIcon: testActiveIcon,
        },
        {
            path: '/game-labs',
            name: i18n.global.t('gameLabs_title'),
            id: 'gameLabs',
            icon: gameLabIcon,
            activeIcon: gameLabActiveIcon,
        },
        {
            path: '/agents',
            name: i18n.global.t('agents_title'),
            id: 'agents',
            icon: agentsIcon,
            activeIcon: agentsActiveIcon,
        },
        {
            path: '/blogs',
            name: i18n.global.t('blogs_title'),
            id: 'blogs',
            icon: blogsIcon,
            activeIcon: blogsActiveIcon,
        },
    ],
    app: [
        {
            path: '/social',
            name: i18n.global.t('social'),
            id: 'social',
            icon: socialIcon,
            activeIcon: socialIcon,
        },
        {
            path: '/reviews',
            name: i18n.global.t('reviews_title'),
            id: 'reviews',
            icon: reviewsIcon,
            activeIcon: reviewsActiveIcon,
        },
        {
            path: '/moods',
            name: i18n.global.t('moods'),
            id: 'moods',
            icon: moodsIcon,
            activeIcon: moodsActiveIcon,
        },
        {
            path: '/tags',
            name: i18n.global.t('tags_title'),
            id: 'tags',
            icon: tagsIcon,
            activeIcon: tagsActiveIcon,
        },
        {
            path: '/gamification',
            name: i18n.global.t('gamification_title'),
            id: 'gamification',
            icon: gamificationIcon,
            activeIcon: gamificationActiveIcon,
        },
        {
            path: '/pages',
            name: i18n.global.t('pages_title'),
            id: 'pages',
            icon: pagesIcon,
            activeIcon: pagesActiveIcon,
        },
        {
            path: '/onboarding',
            name: i18n.global.t('onboarding_title'),
            id: 'onboardings',
            icon: planeIcon,
            activeIcon: planeActiveIcon,
        },
    ],
    tracking: [
        {
            path: '/companies',
            name: i18n.global.t('companies_title'),
            id: 'companies',
            icon: companyIcon,
            activeIcon: companyActiveIcon,
        },
        {
            path: '/users',
            name: i18n.global.t('users_title'),
            id: 'users',
            icon: userIcon,
            activeIcon: userActiveIcon,
        },
        {
            path: '/experts',
            name: i18n.global.t('experts_title'),
            id: 'experts',
            icon: expertIcon,
            activeIcon: expertActiveIcon,
        },
        {
            path: '/journeys',
            name: i18n.global.t('journeys_type'),
            id: 'journeys',
            icon: journeyIcon,
            activeIcon: journeyActiveIcon,
        },
        {
            path: '/reports',
            name: i18n.global.t('reports.reports_title'),
            id: 'reports',
            icon: reportsIcon,
            activeIcon: reportsActiveIcon,
        },
        {
            path: '/notifications',
            name: i18n.global.t('notifications_title'),
            id: 'notifications',
            icon: notificationsIcon,
            activeIcon: notificationsActiveIcon,
        },
        {
            path: '/files',
            name: i18n.global.t('files_title'),
            id: 'files',
            icon: filesIcon,
            activeIcon: filesActiveIcon,
        },
        {
            path: '/userflow',
            name: i18n.global.t('userflow_title'),
            id: 'ruleSet',
            icon: commandIcon,
            activeIcon: commandActiveIcon,
        },
        {
            path: '/dashboard',
            name: i18n.global.t('dashboard'),
            id: 'dashboard',
            icon: dashboardIcon,
            activeIcon: dashboardActiveIcon,
        },
    ],
    sales: [
        {
            path: '/marketplace',
            name: i18n.global.t('marketplace_title'),
            id: 'marketplace',
            icon: marketplaceIcon,
            activeIcon: marketplaceActiveIcon,
        },
        {
            path: '/billing',
            name: i18n.global.t('billing_title'),
            id: 'pricing',
            icon: pricingIcon,
            activeIcon: pricingActiveIcon,
        },
    ]
};

const flattenedMenuRoutes = [
    ...menuRoutes.content,
    ...menuRoutes.app,
    ...menuRoutes.tracking,
    ...menuRoutes.sales
].map(route => ({
    ...route,
}));

export { flattenedMenuRoutes };

export default menuRoutes;
